<ion-input [label]="label"
           labelPlacement="stacked"
           #input
           mode="md"
           class="ts-body"
           (click)="_inputCallback($event)"
           fill="solid"
           [placeholder]="placeholder"
           [formControl]="control">
    <ion-icon *ngIf="iconName"
              class="font-medium"
              slot="end"
              (click)="_iconCallback($event)"
              [name]="iconName" aria-hidden="true"></ion-icon>
</ion-input>
